@if (errors?.required) {
  <div class="text-light-grey text-danger">
    <fa-icon icon="info-circle"></fa-icon>
    Champ obligatoire
  </div>
}
@if (errors?.email) {
  <div class="text-light-grey text-danger">
    <fa-icon icon="info-circle"></fa-icon>
    Email invalide
  </div>
}
@if (errors?.phone) {
  <div class="text-light-grey text-danger">
    <fa-icon icon="info-circle"></fa-icon>
    Numéro de téléphone invalide
  </div>
}
